/**
 * @Author: hangbale
 * @Date:   2017-10-13
 * @Email:  571312070@qq.com
 * @Last modified by:   hangbale
 * @Last modified time: 2017-10-13
 */

<template>
    <div id="" class="multiselect-wrapper">
        <input v-model="inputValue" type="text" name="" value="" :class="{active: inputFocus}" class="select-input" @focus="focus()" @blur="blur($event)">
        <ul class="select-option" :class="{inputFocus: inputFocus}" @click="setOption($event)">
            <li v-for="elem in options" :key="elem.key">{{elem}}</li>
        </ul>
    </div>
</template>
<script>
export default {
    name: "multiselect",
    props: ['options'],
    data: () => ({
        isActive: false,
        selection: {},
        inputFocus: false,
        liClicked: false,
        inputValue: ''
    }),
    methods: {
        setOption ($event) {
            this.inputFocus = true;
            this.liClicked = true;
            var t = $event.target;
            var cls = t.getAttribute('class');
            if (t.nodeName === 'LI') {
                $event.target.classList.toggle('active');
            }
            if (t.getAttribute('class').indexOf('active') > -1) {
                this.selection[t.innerHTML] = t.innerHTML;
            } else {
                this.selection[t.innerHTML] = null;
            }
            var s = '';
            for (var oKey in this.selection) {
                if (this.selection[oKey]) {
                    s += oKey + ','
                }
            }
            s = s.slice(0, -1);
            this.inputValue = s;
            this.$emit('selected', this.inputValue);
            this.liClicked = false;
        },
        focus () {
            this.inputFocus = true;
        },
        blur (e) {
            setTimeout(() => {
              this.inputFocus = this.liClicked;
            }, 150)
        }
    }
}
</script>
<style lang="scss" scoped>
.multiselect-wrapper {

    position: relative;
    .select-input {
        width: 100%;
        height: 32px;
        line-height: 32px;
        box-sizing: border-box;
        outline: none;
        &.active {
            border-color: #0666B2;
        }

    }
    .select-option {
        max-height: 300px;
        overflow-y: scroll;
        &.inputFocus {
            display: block;
        }
        display: none;
        position: absolute;
        top: 32px;
        width: 100%;
        border: 2px solid #0666B2;
        border-top-color: transparent;
        box-sizing: border-box;
        border-top: none;
        background-color: #fff;

        li {
            padding: 15px 20px 15px 10px;
            position: relative;
            text-overflow:ellipsis;
            white-space:nowrap;
            overflow-x:hidden;
            /*max-width: 130px;*/
            &.active {
                color: #0666B2;
                &:after {
                    position: absolute;
                    content: "\2714";
                    top: 15px;
                    right: 5px;
                }
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// multiselect.vue?3c4f08bb